import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { Comunidad, GenericResponse, SaveComunidadDto, SearchComunidadRequest, TipoComunidad, ComunidadAdjunto, UploadComunidadSegurosAttachResponseDto, ComunidadSeguros, EmpleadoComunidad, GenericSearchResponse, UsuarioComunidadDto, ComunidadTipoGastoConceptoRecargoDto } from "../model/index";
import { UploadComunidadAttachResponseDto, ComunidadNumeroEmergencia, ComunidadTiposGastos, TipoGastoComunidadServicioGasto } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})

export class ComunidadService extends CrudService<Comunidad, number, SaveComunidadDto, SearchComunidadRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'comunidad', sharedFunctions);

  }

  getComunidadesDashboard(): Observable<GenericResponse<SearchComunidadRequest>> {
    return this._http.get<GenericResponse<SearchComunidadRequest>>(this._serviceUrl + '/dashboard', this.httpOptions);
  }

  getAttachments(id: number): Observable<GenericResponse<ComunidadAdjunto[]>> {
    return this._http.get<GenericResponse<ComunidadAdjunto[]>>(this._serviceUrl + '/' + id + '/adjuntos', this.httpOptions);
  }

  getSeguros(id: number): Observable<GenericResponse<ComunidadSeguros[]>> {
    return this._http.get<GenericResponse<ComunidadSeguros[]>>(this._serviceUrl + '/' + id + '/seguros', this.httpOptions);
  }

  getNumerosEmergencia(id: number): Observable<GenericResponse<ComunidadNumeroEmergencia[]>> {
    return this._http.get<GenericResponse<ComunidadNumeroEmergencia[]>>(this._serviceUrl + '/' + id + '/numeros-emergencia', this.httpOptions);
  }

  getUsuarios(id: number): Observable<GenericResponse<UsuarioComunidadDto[]>> {
    return this._http.get<GenericResponse<UsuarioComunidadDto[]>>(this._serviceUrl + '/' + id + '/usuarios', this.httpOptions);
  }

  getTiposGasto(id: number): Observable<GenericResponse<ComunidadTiposGastos[]>> {
    return this._http.get<GenericResponse<ComunidadTiposGastos[]>>(this._serviceUrl + '/' + id + '/tipos-gasto', this.httpOptions);
  }

  getTiposGastoConceptoRecargo(id: number): Observable<GenericResponse<ComunidadTipoGastoConceptoRecargoDto[]>> {
    return this._http.get<GenericResponse<ComunidadTipoGastoConceptoRecargoDto[]>>(this._serviceUrl + '/' + id + '/tipos-gasto-concepto-recargo', this.httpOptions);
  }

  getAll(p: SearchComunidadRequest): Observable<GenericSearchResponse<Comunidad>> {
    var queryString = this.sharedFunctions.convertToQueryString(p);
    return this._http.get<GenericSearchResponse<Comunidad>>(this._serviceUrl + '/all' + queryString, this.httpOptions);
  }

  getTiposGastoServicios(id: number): Observable<GenericResponse<TipoGastoComunidadServicioGasto[]>> {
    return this._http.get<GenericResponse<TipoGastoComunidadServicioGasto[]>>(this._serviceUrl + '/' + id + '/tipos-gasto-servicio', this.httpOptions);
  }

  uploadAttachTempUrl(): string {
    return this._serviceUrl + '/attach/temp';
  }

  uploadAttachTemp(p: any): Observable<GenericResponse<UploadComunidadAttachResponseDto>> {
    const formData = new FormData();

    if (p != null) {
      for (let i = 0; i < p.length; i++) {
        const file = p[i];
        if (file != null)
          formData.append('uploadFiles', file);
      }
    }

    return this._http.post<GenericResponse<UploadComunidadAttachResponseDto>>(this.uploadAttachTempUrl(), formData, this.httpFormDataOptions);
  }

  uploadSeguroAttachTempUrl(): string {
    return this._serviceUrl + '/attach-seguro/temp';
  }

  uploadSeguroAttachTemp(p: any): Observable<GenericResponse<UploadComunidadSegurosAttachResponseDto>> {
    const formData = new FormData();

    if (p != null) {
      for (let i = 0; i < p.length; i++) {
        const file = p[i];
        if (file != null)
          formData.append('uploadFiles', file);
      }
    }

    return this._http.post<GenericResponse<UploadComunidadSegurosAttachResponseDto>>(this.uploadSeguroAttachTempUrl(), formData, this.httpFormDataOptions);
  }
}